import { c as _c } from "react/compiler-runtime";
import './jumbotron-sidekick.scss';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.ts';
import { FeatureCard } from '../../../molecules/feature-card/feature-card.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';
export const JumbotronSidekick: React.FC<FlexibleContentProps> = t0 => {
  const $ = _c(32);
  let alt;
  let inline;
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      seoLevel: t2,
      inline: t3,
      alt: t4,
      items: _items,
      ...t5
    } = t0;
    t1 = t2;
    inline = t3;
    alt = t4;
    props = t5;
    $[0] = t0;
    $[1] = alt;
    $[2] = inline;
    $[3] = props;
    $[4] = t1;
  } else {
    alt = $[1];
    inline = $[2];
    props = $[3];
    t1 = $[4];
  }
  const seoLevel = t1 === undefined ? 2 : t1;
  const imagePlacement = alt ? "right" : "left";
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[5] !== alt || $[6] !== inline || $[7] !== props || $[8] !== seoLevel) {
    const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);
    const t6 = !inline;
    if ($[14] !== alt || $[15] !== t6) {
      t5 = cn("JumbotronSidekick component--container", {
        "JumbotronSidekick--alt": alt,
        component: t6
      });
      $[14] = alt;
      $[15] = t6;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    const t7 = !inline;
    if ($[17] !== t7) {
      t4 = cn("JumbotronSidekick__container", {
        container: t7
      });
      $[17] = t7;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    T0 = FeatureCard;
    t2 = props;
    t3 = getBaseSizeProps(headerDisplayLevel);
    $[5] = alt;
    $[6] = inline;
    $[7] = props;
    $[8] = seoLevel;
    $[9] = T0;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    T0 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
  }
  const t6 = seoLevel === 1 ? "lg" : "md";
  let t7;
  if ($[19] !== T0 || $[20] !== imagePlacement || $[21] !== seoLevel || $[22] !== t2 || $[23] !== t3 || $[24] !== t6) {
    t7 = <T0 {...t2} {...t3} seoLevel={seoLevel} titleSize={t6} imagePlacement={imagePlacement} variant="horizontal" buttonVariant="grow" hasPlaceholder={true} />;
    $[19] = T0;
    $[20] = imagePlacement;
    $[21] = seoLevel;
    $[22] = t2;
    $[23] = t3;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t4 || $[27] !== t7) {
    t8 = <div className={t4}>{t7}</div>;
    $[26] = t4;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t5 || $[30] !== t8) {
    t9 = <section className={t5}>{t8}</section>;
    $[29] = t5;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
};